import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3ddce28"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Producer code / agency name:")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 6 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Producer summary:")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "producer-section" }
const _hoisted_16 = { class: "producer-caption" }
const _hoisted_17 = { class: "producer-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Producer code", -1))
const _hoisted_19 = { class: "producer-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Organization", -1))
const _hoisted_21 = { class: "producer-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Address", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { key: 7 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Commission summary:")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = {
  key: 0,
  class: "commission-section"
}
const _hoisted_29 = { class: "commission-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Finance users", -1))
const _hoisted_31 = {
  key: 0,
  class: "commission-field"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Commission user", -1))
const _hoisted_33 = { class: "commission-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Commission plan", -1))
const _hoisted_35 = {
  key: 1,
  class: "commission-field"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Tipalti status", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Tipalti status", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://app.getguru.com/card/TMK8Rjac/What-is-Tipalti-How-do-we-pay-commissions",
  target: "_blank"
}, "Learn more", -1))
const _hoisted_41 = { key: 8 }
const _hoisted_42 = { class: "commission-section" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commission-field" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Finance users"),
  /*#__PURE__*/_createTextVNode(": N/A ")
], -1))
const _hoisted_44 = { class: "commission-field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Commission plan", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commission-field" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tipalti status"),
  /*#__PURE__*/_createTextVNode(": N/A ")
], -1))
const _hoisted_47 = { class: "producer-parent-section" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": This producer does not receive commission for policies bound through Attune. Commission is paid out by their parent organization(s): ")
], -1))
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Secondary code: ")
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Referrer code: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommissionTable = _resolveComponent("CommissionTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        ref: "searchInput",
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSearchString && _ctx.updateSearchString(...args))),
        class: "search-input"
      }, null, 544),
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clearSearch()), ["prevent"])),
        href: "",
        class: "search-clear"
      }, [
        _createElementVNode("img", {
          src: `${_ctx.publicPath}icons/close.svg`,
          alt: "X"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _hoisted_5,
    (_ctx.hasProducerError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " There was an error retrieving producer "))
      : _createCommentVNode("", true),
    (_ctx.hasPayeeError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " There was an error retrieving payee "))
      : _createCommentVNode("", true),
    (_ctx.hasFinanceAdminError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " There was an error retrieving finance admins "))
      : _createCommentVNode("", true),
    (_ctx.hasProducerHierarchyError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " There was an error retrieving producer hierarchy "))
      : _createCommentVNode("", true),
    (_ctx.hasCommissionUserError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " There was an error retrieving commission user "))
      : _createCommentVNode("", true),
    (_ctx.producerSearchString && !_ctx.producerInfo && !_ctx.hasProducerError && !_ctx.hasPayeeError && !_ctx.hasCommissionUserError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.producerInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.producerInfo.AgentGroup || 'Agency name unavailable'), 1),
            _createElementVNode("span", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(": " + _toDisplayString(_ctx.producerInfo.ProducerCode || 'Unavailable'), 1)
            ]),
            _createElementVNode("span", _hoisted_19, [
              _hoisted_20,
              _createTextVNode(": " + _toDisplayString(_ctx.producerInfo.Organization || 'Unavailable'), 1)
            ]),
            _createElementVNode("span", _hoisted_21, [
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.getAddressReadable(_ctx.producerInfo)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.producerInfo && _ctx.financeAdminInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          (!_ctx.receivesNoCommission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, [
                  _hoisted_30,
                  _createTextVNode(": " + _toDisplayString(_ctx.getFinanceAdminsReadable(_ctx.financeAdminInfo)), 1)
                ]),
                (_ctx.commissionUserInfo)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                      _hoisted_32,
                      _createTextVNode(": " + _toDisplayString(_ctx.getCommissionUserReadable(_ctx.commissionUserInfo)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_33, [
                  _hoisted_34,
                  _createTextVNode(": " + _toDisplayString(_ctx.getCommPlanReadable(_ctx.producerInfo.CommissionPlan)), 1)
                ]),
                (_ctx.payeeInfo)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      (_ctx.hasPayeeSetup(_ctx.payeeInfo))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                            _hoisted_37,
                            _createTextVNode(": " + _toDisplayString(_ctx.getTipaltiStatus(_ctx.payeeInfo)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.hasPayeeSetup(_ctx.payeeInfo))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                            _hoisted_39,
                            _createTextVNode(": " + _toDisplayString(_ctx.getTipaltiStatus(_ctx.payeeInfo)) + " ", 1),
                            _hoisted_40
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_CommissionTable, {
            producerCode: _ctx.producerInfo.ProducerCode
          }, null, 8, ["producerCode"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.producerInfo && _ctx.receivesNoCommission)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("span", _hoisted_44, [
              _hoisted_45,
              _createTextVNode(": " + _toDisplayString(_ctx.getCommPlanReadable(_ctx.producerInfo.CommissionPlan)), 1)
            ]),
            _hoisted_46
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("ul", null, [
              (_ctx.hasSecondaryCode)
                ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.navigateToProducer(_ctx.producerHierarchyInfo.SecondaryCode)), ["prevent"]))
                    }, _toDisplayString(_ctx.producerHierarchyInfo.SecondaryCode), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasReferrerCode)
                ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.navigateToProducer(_ctx.producerHierarchyInfo.ReferrerCode)), ["prevent"]))
                    }, _toDisplayString(_ctx.producerHierarchyInfo.ReferrerCode), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}